var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { serializePriceMode } from "../rna-fish/KitSerializer";
import { RnaCishEditableOrganism } from "./ProbeSetForm";
import { EnzymeEnum } from "./RnaCatalog";
import { NONE_ID } from "./RnaCishKitToAdminFormState";
var AutomatedProKitSerializer = /** @class */ (function () {
    function AutomatedProKitSerializer(protocolType, config, plexity, scale, detectPresetScale, chromogenPresetScale) {
        var _this = this;
        this.protocolType = protocolType;
        this.config = config;
        this.plexity = plexity;
        this.scale = scale;
        this.detectPresetScale = detectPresetScale;
        this.chromogenPresetScale = chromogenPresetScale;
        this.setProbeSetState = function (state) {
            _this.probeSetState = state;
        };
        this.setDetect = function (state) {
            _this.detectState = state;
        };
        this.setChromogenComponent = function (state) {
            _this.chromogenState = state;
        };
        this.setMiscComponent = function (state) {
            _this.miscComponentState = state;
        };
        this.serializeKit = function (comment, reasonForOther) {
            var _a, _b, _c, _d, _e, _f, _g;
            var kit = {
                protocolType: _this.protocolType.id,
                config: _this.config,
                plexity: _this.plexity,
                comment: comment,
                reasonForOther: reasonForOther,
                starterKit: false,
                priceModes: {
                    probeSetMode: (_b = (_a = _this.probeSetState) === null || _a === void 0 ? void 0 : _a.map(function (s) { return ({
                        priceModeRequest: serializePriceMode(s.state.customPrice),
                        channel: s.channel
                    }); })) !== null && _b !== void 0 ? _b : [],
                    amplifierMode: serializePriceMode((_c = _this.detectState) === null || _c === void 0 ? void 0 : _c.customPrice),
                    chromogenMode: serializePriceMode((_d = _this.chromogenState) === null || _d === void 0 ? void 0 : _d.customPrice),
                    miscMode: serializePriceMode((_e = _this.miscComponentState) === null || _e === void 0 ? void 0 : _e.customPrice)
                },
                probeSetComponent: (_g = (_f = _this.probeSetState) === null || _f === void 0 ? void 0 : _f.map(function (s) { return AutomatedProKitSerializer.serializeProbeSetState(s.state, s.channel, s.metadata, _this.scale); })) !== null && _g !== void 0 ? _g : []
            };
            if (_this.detectState) {
                kit.detectComponent = AutomatedProKitSerializer.serializeDetect(_this.detectState, _this.detectPresetScale, _this.scale);
            }
            if (_this.chromogenState) {
                kit.chromogenComponent = AutomatedProKitSerializer.serializeChromogenComponent(_this.chromogenState, _this.chromogenPresetScale, _this.scale);
            }
            if (_this.miscComponentState) {
                kit.miscComponent = AutomatedProKitSerializer.serializeMiscComponent(_this.miscComponentState);
            }
            return {
                _type: "rna-cish",
                kit: kit
            };
        };
    }
    AutomatedProKitSerializer.serializeCustomProbeSet = function (organism, target, hcrAmplifier, probeLotNumber) {
        var jsonTarget = {
            name: target.name,
            accession: target.accession,
            targetMrnaSeq: target.targetMrnaSeq
        };
        if (organism.id !== RnaCishEditableOrganism.default().id) {
            return {
                '_type': 'libraryOrganismCustomTarget',
                organism: {
                    id: organism.id,
                },
                target: jsonTarget,
                hcrAmplifier: hcrAmplifier.id,
                probeSetSize: target.probeSetSize,
                probeLotNumber: probeLotNumber
            };
        }
        else {
            return {
                '_type': 'otherOrganismCustomTarget',
                organism: {
                    name: organism.name
                },
                target: jsonTarget,
                hcrAmplifier: hcrAmplifier.id,
                probeSetSize: target.probeSetSize,
                probeLotNumber: probeLotNumber
            };
        }
    };
    AutomatedProKitSerializer.serializeProbeSetState = function (p, channel, presetScale, scale) {
        var _a, _b, _c, _d, _e;
        var probeSetComponent;
        var organism = p.organism;
        var target = p.target;
        if (p.target.variantId != null) {
            var id = p.target.variantId;
            probeSetComponent = {
                probeSet: {
                    _type: 'catalog',
                    id: id,
                    hcrAmplifier: p.hcrAmplifier.id,
                    probeLotNumber: p.probeLotNumber,
                    customerOrganismName: organism.displayName(),
                    customerTargetName: target.name,
                    customerAccessionNum: target.accession,
                    customerSequence: target.targetMrnaSeq,
                    customerProbeSetSize: target.probeSetSize
                }
            };
        }
        else if (p.organism.id !== RnaCishEditableOrganism.default().id) {
            probeSetComponent = {
                probeSet: AutomatedProKitSerializer.serializeCustomProbeSet(p.organism, p.target, p.hcrAmplifier, p.probeLotNumber)
            };
        }
        else {
            probeSetComponent = {
                probeSet: AutomatedProKitSerializer.serializeCustomProbeSet(p.organism, p.target, p.hcrAmplifier, p.probeLotNumber)
            };
        }
        probeSetComponent = __assign(__assign({}, probeSetComponent), { _type: "pro", channel: channel, presetScaleId: (_a = presetScale === null || presetScale === void 0 ? void 0 : presetScale.id) !== null && _a !== void 0 ? _a : null, customScaleSlides: (presetScale === null || presetScale === void 0 ? void 0 : presetScale.id) == null ? scale : null, pmol: (_b = presetScale === null || presetScale === void 0 ? void 0 : presetScale.probeSetScalePmol) !== null && _b !== void 0 ? _b : p.probeScalePmol, volume: (_c = presetScale === null || presetScale === void 0 ? void 0 : presetScale.probeSetScaleUl) !== null && _c !== void 0 ? _c : p.probeScaleUl, probeHybridizationAScaleUl: (_d = presetScale === null || presetScale === void 0 ? void 0 : presetScale.probeHybridizationBufferUl) !== null && _d !== void 0 ? _d : p.probeHybridizationAScale, probeHybridizationBScaleUl: (_e = presetScale === null || presetScale === void 0 ? void 0 : presetScale.probeHybridizationBufferUl) !== null && _e !== void 0 ? _e : p.probeHybridizationBScale });
        return probeSetComponent;
    };
    AutomatedProKitSerializer.serializeDetect = function (a, presetScale, scale) {
        var _a;
        var channels = a.channels.map(function (ch, index) { return (__assign(__assign({ amplifier: ch.hcrAmplifier.id === NONE_ID ? undefined : ch.hcrAmplifier.id, hapten: ch.hcrAmplifier.id === NONE_ID || ch.hapten.id === NONE_ID ? undefined : ch.hapten.id, detectAntiHaptenUl: ch.hcrAmplifier.id === NONE_ID ? 0 : ch.detectAntiHaptenUl, detectTyramideUl: ch.hcrAmplifier.id === NONE_ID ? 0 : ch.detectTyramideUl, detectHrpQuencherUl: ch.hcrAmplifier.id === NONE_ID ? 0 : ch.detectHrpQuencherUl }, AutomatedProKitSerializer.detectEnzymeScales(ch.enzyme, ch)), { enzyme: ch.enzyme.id === NONE_ID ? undefined : ch.enzyme.id, channel: index + 1 })); });
        var detectBDisabled = channels.every(function (c) { return c.amplifier == null; });
        return {
            _type: "pro",
            prefilled: a.prefilled,
            proDetectPresetScaleId: (_a = presetScale === null || presetScale === void 0 ? void 0 : presetScale.id) !== null && _a !== void 0 ? _a : null,
            customScaleSlides: (presetScale === null || presetScale === void 0 ? void 0 : presetScale.id) == null ? scale : null,
            pretreatADewaxUl: a.pretreatADewaxUl,
            pretreatBAntigenRetrievalUl: a.pretreatBAntigenRetrievalUl,
            pretreatBloxolUl: a.pretreatBloxolUl,
            detectAUl: a.detectAUl,
            detectBUl: detectBDisabled ? 0 : a.detectBUl,
            detectBPmol: detectBDisabled ? 0 : a.detectBPmol,
            detectBConcentration: detectBDisabled ? 0 : a.detectBConcentration,
            detectCUl: a.detectCUl,
            postProcessAUl: a.postProcessAUl,
            postProcessBUl: a.postProcessBUl,
            preHybridizationUl: a.preHybridizationUl,
            channels: channels
        };
    };
    AutomatedProKitSerializer.serializeMiscComponent = function (misc) {
        return {
            description: misc.description,
            scaleInSlides: misc.scaleInSlides,
            scaleInMl: misc.scaleInMl
        };
    };
    AutomatedProKitSerializer.serializeChromogenComponent = function (c, presetScale, scale) {
        var _a;
        if (c.chromogen.id === NONE_ID) {
            return null;
        }
        return {
            presetScaleId: (_a = presetScale === null || presetScale === void 0 ? void 0 : presetScale.id) !== null && _a !== void 0 ? _a : null,
            customScaleSlides: (presetScale === null || presetScale === void 0 ? void 0 : presetScale.units) == null ? scale : null,
            chromogenId: c.chromogen.id,
            chromogenBufferId: c.chromogenBuffer.id,
            chromogenScaleUl: c.chromogenScaleUl,
            chromogenBufferScaleUl: c.chromogenBufferScaleUl,
            hematoxylinScaleUl: c.hematoxylinScaleUl
        };
    };
    AutomatedProKitSerializer.detectEnzymeScales = function (enzyme, channel) {
        if (enzyme == null || enzyme.id === NONE_ID) {
            return { detectEnzymeApUl: 0, detectEnzymeHrpUl: 0 };
        }
        if (enzyme.id === EnzymeEnum.AP) {
            return { detectEnzymeApUl: channel.detectEnzymeApUl, detectEnzymeHrpUl: 0 };
        }
        if (enzyme.id === EnzymeEnum.HRP) {
            return { detectEnzymeApUl: 0, detectEnzymeHrpUl: channel.detectEnzymeHrpUl };
        }
        return {
            detectEnzymeApUl: channel.detectEnzymeApUl,
            detectEnzymeHrpUl: channel.detectEnzymeHrpUl
        };
    };
    return AutomatedProKitSerializer;
}());
export default AutomatedProKitSerializer;
//# sourceMappingURL=KitSerializer.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/automated-pro/KitSerializer.js
// module id = 593
// module chunks = 0